<template>
  <li
    v-show="visible"
    class="vs-component"
    :data-text="text"
    @blur="handleBlur"
    @click="clickOption"
    @mouseover="handleMouseover"
    @mouseout="handleMouseout"
  >
    <button
      ref="item"
      class="vs-select--item"
      :class="[
        $attrs.class,
        {
          activex: isActive,
          'con-icon': select.multiple,
          disabledx: disabledByLimit,
        },
      ]"
      :style="[$attrs.style, itemStyle]"
      :disabled="disabled"
      type="button"
      name="button"
      v-bind="buttonAttrs"
      @keydown.backspace.prevent="backspace"
      @keydown.down.prevent="navigate(1)"
      @keydown.up.prevent="navigate(-1)"
      @keydown.enter.prevent="clickOption"
    >
      <vs-icon
        v-if="select.multiple"
        class="icon-item vs-select--item-icon"
        icon="check_circle"
      />
      <span v-html="displayText" />
    </button>
  </li>
</template>

<script>
export default {
  name: "VsSelectItem",
  inheritAttrs: false,
  inject: ["vsSelect"],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    text: {
      default: null,
    },
  },
  emits: ["update:isSelected", "mouseover", "mouseout"],
  data() {
    return {
      visible: true,
      filterValue: "",
    };
  },
  computed: {
    select() {
      return this.vsSelect;
    },
    isActive() {
      if (this.select.multiple) {
        const values = Array.isArray(this.select.currentValue)
          ? this.select.currentValue
          : [];
        return values.includes(this.value);
      }
      return this.select.currentValue == this.value;
    },
    disabledByLimit() {
      if (!this.select.multiple || this.isActive) return false;
      const values = Array.isArray(this.select.currentValue)
        ? this.select.currentValue
        : [];
      return (
        this.select.maxSelected !== null &&
        values.length === Number(this.select.maxSelected)
      );
    },
    itemStyle() {
      if (!this.isActive) return {};
      const color = this.select.color;
      const resolved =
        color.startsWith("#") || color.startsWith("rgb")
          ? color
          : `rgba(var(--vs-${color}), 1)`;
      return {
        background: resolved.replace(/,\s*1\)$/, ", .1)"),
        color: resolved,
        fontWeight: "bold",
      };
    },
    displayText() {
      if (!this.filterValue) return this.text;
      const escaped = this.filterValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return String(this.text).replace(
        new RegExp(escaped, "i"),
        (match) => `<span class="searchx">${match}</span>`
      );
    },
    buttonAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style"].forEach((key) => delete attrs[key]);
      return attrs;
    },
  },
  watch: {
    isActive: {
      immediate: true,
      handler(value) {
        this.$emit("update:isSelected", value);
      },
    },
  },
  created() {
    this.select.registerItem(this);
  },
  beforeUnmount() {
    this.select.unregisterItem(this);
  },
  methods: {
    focus() {
      this.$nextTick(() => this.$refs.item && this.$refs.item.focus());
    },
    clickOption() {
      this.select.selectItem(this);
    },
    backspace() {
      if (!this.select.autocomplete) return;
      const input = this.select.$refs.inputselect;
      input.value = input.value.slice(0, -1);
      input.focus();
    },
    navigate(offset) {
      const items = this.select.visibleItems;
      const index = items.indexOf(this);
      const next = items[(index + offset + items.length) % items.length];
      if (next) next.focus();
    },
    handleBlur(event) {
      if (
        !event.relatedTarget ||
        !event.relatedTarget.closest(".vs-select--options")
      ) {
        this.select.closeOptions();
      }
    },
    handleMouseover(event) {
      this.$emit("mouseover", event);
    },
    handleMouseout(event) {
      this.$emit("mouseout", event);
    },
  },
};
</script>
